import { render, staticRenderFns } from "./person-item-research.vue?vue&type=template&id=963f20ee&"
import script from "./person-item-research.vue?vue&type=script&lang=js&"
export * from "./person-item-research.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports